export const ADD_TODO = 'ADD_TODO';
export const REMOVE_TODO = 'REMOVE_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const FAILED_TO_ADD_TODO = 'FAILED_TO_ADD_TODO';
